
import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import {
    Button, setResponsiveMode
} from "office-ui-fabric-react";

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import TooltipInput from '../Shared/TooltipInput';
import ModalMessage from '../Shared/ModalMessage';
import { Row, Col } from "react-flexbox-grid";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faCheckSquare, faCoffee } from '@fortawesome/fontawesome-free-solid';
import Select from 'react-select'

import { getUserLogged } from "../../services/loginClient";
import * as apiClient from "../../services/apiClient";
import Loading from "../Loading/Loading";
import {
    setFlag, getFlag
} from '../Shared/Shared.js';

import '../../custom.css';
import './ValidateHours.css';

setFlag('isMenuColapsado', false);

const ValidateHours = (props) => {
    const constantes = {
        estado: {
            abierto: 1,
            cerrado: 2
        }
    }

    const showConsoleLogDebug = false;
    const history = useHistory();
    const gridRefTeam = useRef();
    const [userLogged, setUserLogged] = useState(getUserLogged());
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');
    const [translations, setTranslations] = useState([]);

    const [persona, setPersona] = useState(null);
    const [team, setTeam] = useState([]);
    const [profSelected, setProfSelected] = useState({});
    const [professionalHours, setProfessionalHours] = useState([]);
    const [showAprovalButton, setAprovalButtonStatus] = useState(false);
    const [showAprovalSection, setAprovalSectionStatus] = useState(false);
    const [period, setPeriod] = useState({});
    const [periods, setPeriods] = useState([]);
    const [position, setPosition] = useState(0);
    const [disableNextPeriod, setDisableNextPeriod] = useState(false);
    const [disablePreviousPeriod, setDisablePreviousPeriod] = useState(false);
    //const [disableAddRow, setDisableAddRow] = useState(false);

    const [windowHeight, setWindowHeight] = useState(0);
    const [domLayout, setDomLayout] = useState('autoHeight');
    //const [gridApi, setGridApi] = useState(null);
    //const [gridRow, setGridRow] = useState(0);
    //const [gridHeight, setGridHeight] = useState(300);
    //const [gridHeight_Aux, setGridHeight_Aux] = useState(0);
    //const [pageSize, setGridPageSize] = useState(50);

    const [dynamicColumns, setDynamicColumnsGridColumns] = useState([]);
    //const [childrens, setChildrens] = useState([]);
    //const [reports, setReports] = useState([]);

    const [messageTitle, setMessageTitle] = useState("");
    const [messageContent, setMessageContent] = useState("");
    const [messageStatus, setMessageStatus] = useState(false);
    const [messageHeaderBackground, setMessageHeaderBackground] = useState('');

    //const maxRows = 5;
    //const rowHeight = 42;
    //let actualRows = reports.length;
    //const gridHeight = maxRows * rowHeight;

    const language = navigator.language.startsWith('es') ? 'es' : 'en';

    useEffect(() => {
        const GetTranslations = async () => {
            if (showConsoleLogDebug)
                console.log("ValidateHours.useEffect().GetTranslations()");

            const labels = await apiClient.GetLabelsByFolderAndControllerAndLabelName(language, "TimesheetTasking", "Validate", "validateHours");
            const data = await apiClient.GetTranslationsByLabels(language, labels);

            setMessage((await data).filter(item => 'validateHours.Loading' == item.label)[0].body);
            setLoading(true);

            setTranslations(data);
        };

        const GetScreenData = async () => {
            if (showConsoleLogDebug)
                console.log("ValidateHours.useEffect().GetScreenData()");

            var currentDate = new Date();
            currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

            var req = getReq();

            var persona = await apiClient.GetPersonaData(language, req);
            var periodos = await apiClient.GetPeriodsBySociety(language, persona.sociedad);
            var disablePreviousPeriod = false;
            var disableNextPeriod = true;

            var position = periodos.findIndex(per => {
                var fechaInicio = per.fechaInicio;
                var fechaFin = per.fechaFin;

                return currentDate >= new Date(fechaInicio) && currentDate <= new Date(fechaFin);
            });

            // En caso de estar fuera de todos los rangos de periodos,
            // se escoge el periodo más reciente si lo hubiera.
            if (-1 == position && periodos.length > 0) {
                position = periodos.length - 1;
            }

            if (periodos.length <= 1) {
                disablePreviousPeriod = true;
            }

            if (position < periodos.length - 1) {
                disableNextPeriod = false;
            }

            var team = await apiClient.GetTeam(language, req, periodos[position].fechaInicio, periodos[position].fechaFin);

            setPersona(persona);
            setTeam(team);
            //setProfSelected({ id: '', nPersonal: '', nombre: '', apellido1: '', apellido2: '', sociedad: '', nombreSociedad: '', horasReportadasPeriodo: 0 });
            setDisablePreviousPeriod(disablePreviousPeriod);
            setDisableNextPeriod(disableNextPeriod);
            setPeriods(periodos);
            setPeriod(periodos[position]);
            setPosition(position);

            checkAprovalStatus(profSelected, [], periodos[position]);
            setLoading(false);
        };

        const OcultarMenu = () => {
            // Establezco un timeout de 500ms porque de lo contrario no puedo determinar
            // si el menú lateral está o no colapsado.
            setTimeout(() => {
                var isFlagColapsado = getFlag('isMenuColapsado');

                if (!isFlagColapsado) {
                    setFlag('isMenuColapsado', true);

                    if (document.getElementById('sidebar-css').offsetWidth > 100) {
                        document.getElementById('menu_open').click();
                    }
                }
            }, 500);
        }

        GetTranslations();
        setLoading(true);
        GetScreenData();
        OcultarMenu();
        AjustarAlturaTabla();

        setInterval(() => {
            let windowHeightAux = $(window.top).height();

            if (windowHeight != windowHeightAux) {
                AjustarAlturaTabla();
            }
        }, 5000);
    }, []);

    const AjustarAlturaTabla = () => {
        //if (totalRows == 5) {
        // Ajustamos el alto de la tabla de imputaciones según los píxeles verticales.
        let gridDivProfesionales = document.querySelector('.team-grid');
        let gridDivHoras = document.querySelector('.hours-grid');
        let windowHeight = $(window.top).height();
        console.log(`>>> windowHeight:  ${windowHeight}`);

        if (windowHeight <= 770) {
            setDomLayout(null);
            /*gridDiv.style.height = `${gridDiv.offsetHeight}px`;*/
            gridDivProfesionales.style.height = `240px`;
            gridDivHoras.style.height = `240px`;
        } else if (windowHeight > 700 && windowHeight <= 930) {
            setDomLayout(null);
            /*gridDiv.style.height = `${gridDiv.offsetHeight}px`;*/
            gridDivProfesionales.style.height = `385px`;
            gridDivHoras.style.height = `240px`;
        } else if (windowHeight > 930 && windowHeight <= 1100) {
            setDomLayout(null);
            gridDivProfesionales.style.height = `500px`;
            gridDivHoras.style.height = `305px`;
        } else {
            setDomLayout(null);
            gridDivProfesionales.style.height = `500px`;
            gridDivHoras.style.height = `305px`;
        }

        setWindowHeight(windowHeight);
    }

    const getGridColumnsTeam = () => {
        if (showConsoleLogDebug)
            console.log("ValidateHours.getGridColumnsTeam()");

        let grid_columns = [
            {
                field: "validado",
                headerName:'', //translations.length > 0 ? translations.filter(translations => translations.label == "validateHours.Validated")[0].body : "",
                type: 'rightAligned',
                filter: "agTextColumnFilter",
                width: 10,
                editable: false,
                resizable: false,
                headerClass: 'text-center',
                lockPosition: 'left',
                cellStyle: () => ({
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }),
                cellRenderer: (field) => {
                    return (field.data.validado) ? <i class="fa fa-check text-success" aria-hidden="true"></i> : '';
                }
            },
            {
                field: "nPersonal",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "validateHours.Number")[0].body : "",
                type: 'rightAligned',
                filter: "agTextColumnFilter",
                width: 110,
                editable: false,
                resizable: true
            },
            {
                field: "nombreCompleto",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "validateHours.FullName")[0].body : "",
                filter: "agTextColumnFilter",
                //filterParams: {
                //    filterOptions: ["contains", "startsWith", "endsWith"],
                //    defaultOption: "startsWith"
                //    //debounceMs: 1000
                //},
                width: 390,
                editable: false,
                resizable: true,
                //cellRenderer: (field) => {
                //    return `${field.data.nombre} ${field.data.apellido1} ${field.data.apellido2}`;
                //}
            },
            {
                field: "nombreSociedad",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "validateHours.Company")[0].body : "",
                filter: "agTextColumnFilter",
                width: 390,
                editable: false,
                resizable: true
            },
            {
                field: "nombreGrupo",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "validateHours.Group")[0].body : "",
                filter: "agTextColumnFilter",
                width: 390,
                editable: false,
                resizable: true
            },
            {
                field: "businessUnit",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "validateHours.BusinessUnit")[0].body : "",
                filter: "agTextColumnFilter",
                width: 300,
                editable: false,
                resizable: true
            },
            {
                field: "horasReportadasPeriodo",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "validateHours.ReportedHours")[0].body : "",
                type: 'rightAligned',
                filter: "agTextColumnFilter",
                width: 90,
                editable: false,
                resizable: true
            }
        ];

        return grid_columns;
    }

    const getGridColumnsHours = () => {
        if (showConsoleLogDebug)
            console.log("ValidateHours.getGridColumnsHours()");

        let grid_columns = [
            {
                field: "projectCode",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "validateHours.CodeProject")[0].body : "",
                //type: 'rightAligned',
                filter: "agTextColumnFilter",
                width: 140,
                pinned: 'left',
                editable: false,
                resizable: true,
                cellRenderer: (field) => {
                    return (
                        <span title={`${field.data.projectCode}`}>{field.data.projectCode}</span>
                    )
                }
            },
            {
                field: "projectName",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "validateHours.Project")[0].body : "",
                //type: 'rightAligned',
                filter: "agTextColumnFilter",
                width: 200,
                pinned: 'left',
                editable: false,
                resizable: true,
                cellRenderer: (field) => {
                    return (
                        <span title={`${field.data.projectName}`}>{field.data.projectName}</span>
                    )
                }
            },
            {
                field: "phaseCode",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "validateHours.CodePhase")[0].body : "",
                //type: 'rightAligned',
                filter: "agTextColumnFilter",
                width: 180,
                pinned: 'left',
                editable: false,
                resizable: true,
                cellRenderer: (field) => {
                    return (
                        <span title={`${field.data.phaseCode}`}>{field.data.phaseCode}</span>
                    )
                }
            },
            {
                field: "phaseName",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "validateHours.PhaseName")[0].body : "",
                //type: 'rightAligned',
                filter: "agTextColumnFilter",
                width: 200,
                pinned: 'left',
                editable: false,
                resizable: true,
                cellRenderer: (field) => {
                    return (
                        <span title={`${field.data.phaseName}`}>{field.data.phaseName}</span>
                    )
                }
            },
            {
                field: "labourCode",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "validateHours.LabourCode")[0].body : "",
                //type: 'rightAligned',
                filter: "agTextColumnFilter",
                width: 200,
                pinned: 'left',
                editable: false,
                resizable: true,
                cellRenderer: (field) => {
                    return (
                        <span title={`${field.data.labourCodeCode} ${field.data.labourCodeName}`}>{field.data.labourCodeCode} {field.data.labourCodeName}</span>
                    )
                }
            }
        ];

        let dynamicColumns = generateColumns(language, new Date(period.fechaInicio), new Date(period.fechaFin));

        return [...grid_columns, ...dynamicColumns];
    }

    const getTranslation = (label) => {
        if (showConsoleLogDebug)
            console.log("ValidateHours.getTranslation()");

        const translation = translations.find((t) => t.label === label);
        return translation ? translation.body : '';
    };

    const getReq = () => {
        return {
            email: userLogged.mail,
            token: userLogged.token
        };
    }

    const generateColumns = (language, startDate, endDate) => {
        if (showConsoleLogDebug)
            console.log("ValidateHours.generateColumns()");

        const columns = [];
        const currentDate = new Date(startDate);
        let lang = language == 'es' ? 'es-ES' : 'en-US';

        while (currentDate <= endDate) {
            const day = currentDate.toLocaleDateString(lang, { weekday: 'short' });
            const dayNumber = formatDateNumber(currentDate.getDate());
            const monthNumber = formatDateNumber(currentDate.getMonth() + 1);
            const yearNumber = currentDate.getFullYear();

            const column = {
                field: `${yearNumber}-${monthNumber}-${dayNumber}`,
                headerName: '', //`${day} ${dayNumber}/${monthNumber}`,
                headerComponentParams: { template: `<span style="white-space:break-spaces;text-align:center;">${day} ${dayNumber}/${monthNumber}</span>` },
                filter: "agTextColumnFilter",
                cellRenderer: (field) => {
                    const [value, setValue] = useState(0);
                    const [resumen, setResumen] = useState(0);

                    const regex = /^(\d+\.?\d{0,2}|\.\d{1,2})$/;
                    const pinned = field.node.rowPinned;

                    //let date = new Date(field.data.fechaImputacion);
                    let reg = field.data.hours.filter((item) => {
                        let aux = new Date(item.fechaImputacion);
                        return (aux.getFullYear() == yearNumber && aux.getMonth() + 1 == monthNumber && aux.getDate() == dayNumber);
                    })[0];

                    if (reg !== undefined) {
                        return (
                            <div>
                                <TooltipInput
                                    horas={reg.horas}
                                    comentario={reg.comentario}
                                    disabled={true}
                                ></TooltipInput>
                            </div>
                        );
                    } else {
                        return (
                            <div>
                                <input class="grid-no-editable-resumen-row input-hours-width" type="text" min="0" max="24" step="0.01" disabled={true} value="" />
                            </div>
                        );
                    }
                },
                width: 70, // 120
                resizable: true,
                editable: false,
            };

            columns.push(column);
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return columns;
    };

    const onGridReady = useCallback((params) => {
        if (showConsoleLogDebug)
            console.log("ValidateHours.onGridReady()");

        //params.api.sizeColumnsToFit();

        window.addEventListener('resize', function () {
            setTimeout(function () {
                params.api.sizeColumnsToFit();
            });
        });
    }, []);

    const autoSizeColumns = params => {
        if (showConsoleLogDebug)
            console.log("ValidateHours.autoSizeColumns()");

        params.api.sizeColumnsToFit();

        //const colIds = params.columnApi
        //    .getAllDisplayedColumns()
        //    .map(col => col.getColField());

        //params.columnApi.autoSizeColumns(colIds, false);
    };

    const onModelTeamUpdated = async () => {
        if (showConsoleLogDebug) console.log("ValidateHours.onModelTeamUpdated()");

        gridRefTeam.current.api.forEachNode((node) => {
            if (node.data.nPersonal == profSelected.nPersonal) {
                node.setSelected(true);
            }
        })
    }

    const onSelectionChanged = async () => {
        if (showConsoleLogDebug)
            console.log("ValidateHours.onSelectionChanged()");

        const selectedRows = gridRefTeam.current.api.getSelectedRows();

        if (selectedRows.length > 0) {
            var req = getReq();
            let nPersonal = selectedRows[0].nPersonal;
            let projectsHours = await generateProjectsHours(nPersonal, period.fechaInicio, period.fechaFin);
            let flagPendingHours = await apiClient.GetValidateHoursPendingFlag(req, nPersonal, period.fechaInicio, period.fechaFin);

            checkAprovalStatus(selectedRows[0], projectsHours, period, flagPendingHours);

            setProfessionalHours(projectsHours);
            setProfSelected(selectedRows[0]);
        }
    };

    const handleFilter = (event) => {
        //alert(gridRef.current.api.getFilterInstance('nombre').appliedModel.filter);
    };

    const generateProjectsHours = async (nPersonal, fechaInicio, fechaFin) => {
        if (showConsoleLogDebug)
            console.log("ValidateHours.generateProjectsHours()");

        var req = getReq();

        let professionalHours = await apiClient.GetProfessionalHours(req, nPersonal, fechaInicio, fechaFin);
        //let projects = [... new Set(professionalHours.map((item) => (!item.esPG) ? item.idProyecto : 'PG' + item.id))]; // Array de proyectos (sin duplicados).
        let projects = professionalHours.reduce((resultado, item, index) => {
            if (resultado.filter(ritem =>
                                    (!item.esPG && !ritem.esPG && ritem.idProyecto == item.idProyecto && ritem.codigoLabourCode == item.codigoLabourCode && ritem.agrupacion_imputacion == item.agrupacion_imputacion)
                                    || (item.esPG && ritem.esPG && ritem.idProyecto == item.idProyectoGeneralFase && ritem.agrupacion_imputacion == item.agrupacion_imputacion)
                            ).length == 0) {
                resultado.push({ idProyecto: (!item.esPG) ? item.idProyecto : item.idProyectoGeneralFase, codigoLabourCode: item.codigoLabourCode, esPG: item.esPG, agrupacion_imputacion: item.agrupacion_imputacion });
            }

            return resultado;
        }, [])

        let projectsHours = [];
        projects.forEach((project) => {
            let nProject = professionalHours.filter((item) => 
                (!project.esPG && !item.esPG && item.idProyecto == project.idProyecto && item.codigoLabourCode == project.codigoLabourCode && item.agrupacion_imputacion == project.agrupacion_imputacion)
                    || (project.esPG && item.esPG && item.idProyectoGeneralFase == project.idProyecto && item.codigoLabourCode == project.codigoLabourCode && item.agrupacion_imputacion == project.agrupacion_imputacion)
            )[0];
            projectsHours.push({
                project: project,
                projectName: nProject.nombreProyecto,
                projectCode: nProject.codigoProyecto,
                phaseName: nProject.nombreFase,
                phaseCode: nProject.codigoFase,
                labourCodeCode: nProject.codigoLabourCode,
                labourCodeName: nProject.nombreLabourCode,
                agrupacion_imputacion: nProject.agrupacion_imputacion,
                hours: professionalHours.filter((item) =>
                    (!project.esPG && !item.esPG && item.idProyecto == project.idProyecto && item.codigoLabourCode == project.codigoLabourCode && item.agrupacion_imputacion == project.agrupacion_imputacion)
                    || (project.esPG && item.esPG && item.idProyectoGeneralFase == project.idProyecto && item.codigoLabourCode == project.codigoLabourCode && item.agrupacion_imputacion == project.agrupacion_imputacion))
            });
        });

        //setProfessionalHours(projectsHours);

        return projectsHours;
    }

    const toPage = (page) => {
        history.push(page);
    };

    function formatDateNumber(num) {
        return num.toString().padStart(2, '0');
    }

    const formatDateString = (date) => {
        var formatDate = [formatDateNumber(date.getDate()), formatDateNumber(date.getMonth() + 1), date.getFullYear()].join('/');
        return formatDate;
    };

    const goToPreviousWeek = async () => {
        if (showConsoleLogDebug)
            console.log("ValidateHours.goToPreviousWeek()");

        setMessage(getTranslation("validateHours.Loading"));
        setLoading(true);

        const language = navigator.language.startsWith('es') ? 'es' : 'en';
        setDynamicColumnsGridColumns([]);

        var pos = position;
        pos = pos - 1;

        var periodo = periods[pos];

        var disablePreviousPeriod = false;
        var disableNextPeriod = false;

        if (pos == 0)
            disablePreviousPeriod = true;

        if (pos == periods.length || periods.length <= 1)
            disableNextPeriod = true;

        var req = getReq();

        var dynamicColumns = generateColumns(language, new Date(periodo.fechaInicio), new Date(periodo.fechaFin));
        var team = await apiClient.GetTeam(language, req, periodo.fechaInicio, periodo.fechaFin);
        let flagPendingHours = await apiClient.GetValidateHoursPendingFlag(req, profSelected.nPersonal, period.fechaInicio, period.fechaFin);

        //if (profSelected.nPersonal !== undefined) {
        //    generateProjectsHours(profSelected.nPersonal, periodo.fechaInicio, periodo.fechaFin);
        //}

        setTeam(team);
        setPosition(pos);

        setDisablePreviousPeriod(disablePreviousPeriod);
        setDisableNextPeriod(disableNextPeriod);

        setPeriod(periodo);
        setDynamicColumnsGridColumns(dynamicColumns);
        checkAprovalStatus(profSelected, professionalHours, periodo, flagPendingHours);

        setLoading(false);
    };

    const goToNextWeek = async () => {
        if (showConsoleLogDebug)
            console.log("ValidateHours.goToNextWeek()");

        setMessage(getTranslation("validateHours.Loading"));
        setLoading(true);

        const language = navigator.language.startsWith('es') ? 'es' : 'en';
        setDynamicColumnsGridColumns([]);

        var pos = position;
        pos = pos + 1;

        var periodo = periods[pos];

        var disablePreviousPeriod = false;
        var disableNextPeriod = false;

        if (pos == 0)
            disablePreviousPeriod = true;

        if (pos == periods.length - 1 || periods.length <= 1)
            disableNextPeriod = true;

        var req = getReq();

        var dynamicColumns = generateColumns(language, new Date(periodo.fechaInicio), new Date(periodo.fechaFin));
        var team = await apiClient.GetTeam(language, req, periodo.fechaInicio, periodo.fechaFin);
        let flagPendingHours = await apiClient.GetValidateHoursPendingFlag(req, profSelected.nPersonal, period.fechaInicio, period.fechaFin);

        //if (profSelected.nPersonal !== undefined) {
        //    generateProjectsHours(profSelected.nPersonal, periodo.fechaInicio, periodo.fechaFin);
        //}

        setTeam(team);
        setPosition(pos);

        setDisablePreviousPeriod(disablePreviousPeriod);
        setDisableNextPeriod(disableNextPeriod);

        setPeriod(periodo);
        setDynamicColumnsGridColumns(dynamicColumns);
        checkAprovalStatus(profSelected, professionalHours, periodo, flagPendingHours);

        setLoading(false);
    };

    const btnDescargar_Click = async (event) => {        
        let req = getReq();
        let response = await apiClient.GetReportTeamHoursFile(language, req, period.fechaInicio, period.fechaFin);
        let filename = await response.headers.get('Content-Disposition').split('filename=')[1].split(';')[0];
        let url = window.URL.createObjectURL(await response.blob());
        let link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const checkAprovalStatus = (professional, hours, period, flagPendingHours) => {
        if (showConsoleLogDebug)
            console.log("ValidateHours.checkAprovalStatus()");

        // Mientras la fecha de cierre sea mayor o igual a la fecha actual, el responsable puede validar las horas.
        // Este flag se utiliza junto con el estado del periodo, que debe ser cerrado para poder llevar a cabo la validación.
        let flagEsValidable = new Date(period.fechaCierre).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0);
        // Estado 1: abierto; estado 2: cerrado.
        //setAprovalButtonStatus(flagEsValidable && undefined != period.idEstado && constantes.estado.cerrado == period.idEstado && undefined != professional.nPersonal && hours.length > 0 && flagPendingHours);
        setAprovalButtonStatus(flagEsValidable && hours.length > 0 && flagPendingHours);
        setAprovalSectionStatus(undefined != professional.nPersonal); // && hours.length > 0); // showAproval
    }

    const validateImputatedHours = async () => {
        if (showConsoleLogDebug)
            console.log("ValidateHours.validateImputatedHours()");

        setMessage(getTranslation("validateHours.Saving"));
        setLoading(true);

        var req = getReq();
        console.log(team);
        let status = await apiClient.ValidateProfessionalImputedHours(req, profSelected.nPersonal, period.fechaInicio, period.fechaFin);

        if (status) {
            var team = await apiClient.GetTeam(language, req, period.fechaInicio, period.fechaFin);
            setTeam(team);
            setMessageTitle(getTranslation("validateHours.OperationResult"));
            setMessageContent(getTranslation("validateHours.ImputationsValidated"));
            setMessageStatus(true);
            setMessageHeaderBackground("bg-success");
            setAprovalButtonStatus(false);
        }
        else {
            setMessageTitle(getTranslation("validateHours.OperationResult"));
            setMessageContent(getTranslation("validateHours.ImputationsNotValidated"));
            setMessageStatus(true);
            setMessageHeaderBackground("bg-danger");
        }

        setLoading(false);
    }

    return (
        <Row>
            <Col xs={12}>
                {
                    loading &&
                    <Loading show={loading} message={message} />
                }

                <ModalMessage
                    title={messageTitle}
                    message={messageContent}
                    show={messageStatus}
                    setMessageStatus={setMessageStatus}
                    headerBackground={messageHeaderBackground}
                    btnCloseText={getTranslation("validateHours.Close")}
                />

                <Row between="xs">
                    <Col xs={12}>
                        <section>
                            <h5>{getTranslation('validateHours.Title')}</h5>
                        </section>
                    </Col>
                </Row>

                <Row between="xs">
                    <Col xs={12}>
                        <section>
                            <Row between="xs">
                                <Col xs={5}>
                                    <div id="goToPreviousWeek">
                                        <h4>
                                            <b>{getTranslation('validateHours.Period')} </b>
                                            <button className="icon-week-button" disabled={disablePreviousPeriod} onClick={goToPreviousWeek}>
                                                <i class="fa fa-angle-left" aria-hidden="true"></i>
                                            </button>
                                        </h4>
                                    </div>
                                    <div id="week">
                                        <label>
                                            <h4>{formatDateString(new Date(period.fechaInicio))} - {formatDateString(new Date(period.fechaFin))}</h4>
                                        </label>
                                    </div>
                                    <div id="goToNextWeek">
                                        <h4>
                                            <button className="icon-week-button" disabled={disableNextPeriod} onClick={goToNextWeek}>
                                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                                            </button>
                                        </h4>
                                    </div>
                                </Col>
                                <Col xs={3}>
                                    <h4>{getTranslation('validateHours.CloseDate')}: {formatDateString(new Date(period.fechaCierre))}</h4>
                                </Col>
                                <Col xs={1} />
                                <Col xs={3}>
                                    <h4 id="statusLabelAlign">{getTranslation('validateHours.Status')}: {period.estado}</h4>
                                </Col>
                            </Row>
                        </section>
                    </Col>
                </Row>

                <Row between="xs">
                    <Col xs={12}>
                        <section className="mb-2">
                            <Row between="xs" className="mb-2">
                                <Col xs={12}>
                                    <div className="table-container">
                                        <button onClick={validateImputatedHours} className={showAprovalButton ? "btn btn-delete-row-margin mr-1" : "not-visible"} >{getTranslation('validateHours.Aproval')}</button>
                                        <button id="btnDescargar" className="btn" onClick={btnDescargar_Click}>{'Download'}</button>
                                    </div>
                                </Col>
                            </Row>

                            <Row between="xs" >
                                <Col xs={12}>
                                    <div className="table-container">
                                        <div className="team-grid ag-theme-alpine">
                                            <AgGridReact
                                                ref={gridRefTeam}
                                                domLayout={domLayout}
                                                pagination={false}
                                                sizeColumnsToFit={true}
                                                rowData={team}
                                                columnDefs={getGridColumnsTeam()}
                                                rowSelection={'single'}
                                                //pinnedBottomRowData={createData(1, 'Bottom')}
                                                //suppressRowClickSelection={true}
                                                stopEditingWhenCellsLoseFocus={true}
                                                getRowStyle={(params) => {
                                                    if (params.node.rowIndex % 2 === 0) {
                                                        return { background: '#ececec' };
                                                    }
                                                }}
                                                defaultColDef={{
                                                    width: 170,
                                                    //filter: true,
                                                    sortable: true
                                                }}
                                                onGridReady={onGridReady}
                                                onFirstDataRendered={autoSizeColumns}
                                                onModelUpdated={onModelTeamUpdated}
                                                onSelectionChanged={onSelectionChanged}
                                                onFilterChanged={handleFilter}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                        </section>
                    </Col>
                </Row>

                <Row between="xs">
                    <Col xs={12}>
                        <section className={showAprovalSection ? "mb-3" : "not-visible"}>
                            <Row between="xs">
                                <Col xs={12}>
                                    <div>
                                        <h4>{getTranslation('validateHours.ReportedHoursPerEmployee')} {profSelected.nombre} {profSelected.apellido1} {profSelected.apellido2}</h4>
                                    </div>
                                </Col>
                            </Row>
                            <Row between="xs">
                                <Col xs={12}>
                                    <div className="hours-grid ag-theme-alpine">
                                        <AgGridReact
                                            domLayout={domLayout}
                                            pagination={false}
                                            sizeColumnsToFit={true}
                                            columnDefs={getGridColumnsHours()}
                                            rowData={professionalHours}
                                            rowSelection={'multiple'}
                                            //pinnedBottomRowData={createData(1, 'Bottom')}
                                            suppressRowClickSelection={true}
                                            stopEditingWhenCellsLoseFocus={true}
                                            getRowStyle={(params) => {
                                                if (params.node.rowIndex % 2 === 0) {
                                                    return { background: '#ececec' };
                                                }
                                            }}
                                            defaultColDef={{
                                                width: 170,
                                                sortable: true
                                            }}

                                            onCellValueChanged={params => {
                                                //setHours(params);
                                            }}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </section>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default ValidateHours;